// extracted by mini-css-extract-plugin
export default {"root":"_2TdHE","widget-header-mobile":"_1Vk3-","widgetHeaderMobile":"_1Vk3-","above-header":"_1yg5E","aboveHeader":"_1yg5E","search-button":"PeMMB","searchButton":"PeMMB"};